export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10435.781b16a9.jpg";